import { Category } from '../models/product.model';

export const MOCK_CATEGORIES: Category[] = [
  { id: 1, nome: 'Faróis', slug: 'farois' },
  { id: 2, nome: 'Lanternas', slug: 'lanternas' },
  { id: 3, nome: 'Retrovisores', slug: 'retrovisores' },
  { id: 4, nome: 'Para-choques', slug: 'para-choques' },
];

